import { memo } from 'react';

import { UserRoundPlusIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

export type ShareLinkTeamInviteNudgePanelProps = {
  onInviteClick: () => void;
  workspaceName?: string;
};

export const ShareLinkTeamInviteNudgePanel = memo(
  ({ onInviteClick, workspaceName = 'workspace' }: ShareLinkTeamInviteNudgePanelProps) => {
    return (
      <div
        className="mt-3 rounded-6 border ads:border-primary-subtle border-blue-3 ads:bg-primary-subtle bg-blue-1 p-6 shadow-popover"
        data-testid="SHARE_LINK_TEAM_INVITE_NUDGE"
      >
        <p className="font-semibold ads:text-primary text-16 text-gray-12">Gather your team in Air</p>
        <p className="mt-1 ads:text-primary text-14 text-gray-12">
          All plans have unlimited seats to make collaboration seamless.
        </p>
        <Button
          appearance="outline"
          className="mt-3 max-w-full overflow-hidden"
          color="blue"
          onClick={onInviteClick}
          prefix={<UserRoundPlusIcon size="sm" />}
          size="medium"
          type="button"
        >
          <span className="truncate">Invite to {workspaceName}</span>
        </Button>
      </div>
    );
  },
);

ShareLinkTeamInviteNudgePanel.displayName = 'ShareLinkTeamInviteNudgePanel';
